import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {HttpClient} from '@angular/common/http';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {first, take} from 'rxjs/operators';
import {CommissionJob} from '../interface/commission-job';
import {Document as DocumentInterface} from "../interface/document";
import {Invoice} from "../interface/invoice";
import {ListResponse} from "../interface/response/list-response";
import {PaymentJob} from "../interface/payment-job";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class PaymentJobService {

  public readonly invoiceListSubject: ReplaySubject<CountedAndPaginated<Invoice>> = new ReplaySubject<CountedAndPaginated<Invoice>>(1);
  public readonly invoiceNotCountedListSubject: ReplaySubject<ListResponse<Invoice>> = new ReplaySubject<ListResponse<Invoice>>(1);
  public readonly jobListSubject: ReplaySubject<CountedAndPaginated<PaymentJob>> = new ReplaySubject<CountedAndPaginated<PaymentJob>>(1);
  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }
  public loadList(page: number, pageSize: number, filters: object, subject?: Subject<CountedAndPaginated<Invoice>>): void {
    this.httpClient.get(`/rest/crm/invoice?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Invoice>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.invoiceListSubject.next(result);
        }
      });
  }
  public loadNotCountedList(page: number, pageSize: number, filters: object, observable?: ReplaySubject<ListResponse<Invoice>>): void {
    this.httpClient
      .get(`/rest/crm/invoice?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<Invoice>) => {
        if (observable) {
          observable.next(result);
        } else {
          this.invoiceNotCountedListSubject.next(result);
        }
      });
  }
  public loadJobList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/payment-job?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<PaymentJob>) => {
        this.jobListSubject.next(result);
      });
  }
  // generatePayment(formData: any): Observable<any> {
  //   const formDataFormatted = {...formData};
  //   formDataFormatted.billingMonth = formDataFormatted.billingMonth.format('YYYY-MM');
  //   return this.httpClient.post(`/rest/crm/payment/job/generate-payment`, formDataFormatted)
  //     .pipe(first());
  // }
  generatePayment(filters: object): Observable<Invoice> {
    return this.httpClient.post(`/rest/crm/payment/job/generate-payment?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Invoice>;
  }
  importPayment(formData: any): Observable<any> {
    const formDataFormatted = {...formData};
    formDataFormatted.billingMonth = formDataFormatted.billingMonth.format('YYYY-MM');
    return this.httpClient.post(`/rest/crm/payment/job/generate-payment`, formDataFormatted)
      .pipe(first());
  }
}
